import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Box, forwardRef } from "@chakra-ui/react";
var Span = forwardRef(function(props, ref) {
    return /*#__PURE__*/ _jsx(Box, _object_spread({
        as: "span",
        ref: ref
    }, props));
});
export default Span;
